export const manager = {
  seo: {
    title: 'Restaurant online beheren met Bistroo Manager | Bistroo',
    description: "Beheer menu's, openingstijden, acties en betalingen vanuit één manager app. De Bistroo Manager voor restaurants & horecaondernemers.",
  },
  hero: {
    title: {
      pt1: 'Een',
      pt2: 'online manager',
      pt3: 'om zelf de regie in handen te houden',
    },
    description:
      'Met de Bistroo Manager-app pas je alles in jouw webshop in slechts enkele seconden aan. Verwerk elke bestelling moeiteloos en blijf altijd de chef in jouw online restaurant.',
    button: 'Ontdek de Manager',
  },
  paragraphs: {
    paragraph_1: {
      title: 'Realtime controle over jouw online shop',
      text: 'Houd de perfecte klantervaring in stand. Pas al je instellingen in realtime aan via de Bistroo Manager. Toegankelijk op al je apparaten, vanaf iedere locatie.',
      cta: 'Verken de Bistroo pakketten',
    },
    paragraph_2: {
      title: 'Perfecte bezorginstellingen',
      text: 'Stem je bezorggebieden perfect af op je capaciteiten van de dag en teken je gewenste gebieden haarscherp op Google Maps. Met de mogelijkheid om je voorwaarden per bezorggebied aan te passen.',
      cta: '',
    },
    paragraph_3: {
      title: 'Inzichten & Rapportages',
      text: 'Geavanceerde inzichten en rapportages zijn beschikbaar via de Manager-app. Pas je voorwaarden aan op basis van datagedreven beslissingen en suggesties van de Manager.',
      cta: 'Verken de Bistroo pakketten',
    },
    paragraph_4: {
      title: 'Stroomlijn jouw processen',
      text: 'Bespaar kostbare tijd en handmatig werk, zonder ooit verrast te worden door te veel bestellingen of onverwacht online verkeer! Pas eenvoudig je piektijd-volume en geschatte levertijden aan met één druk op de knop. Blijf ten alle tijden in controle.',
      cta: '',
    },
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Pas je menu en instellingen eenvoudig aan.',
        text: 'Pas het menu en instellingen van jouw restaurant aan vanaf iedere locatie. Krijg toegang vanaf ieder apparaat, op elk moment en wijzig eenvoudig producten, prijzen, voorraad, kortingen, promoties en bezorggebieden. ',
        button: '',
        img_alt: '',
      },
      card_2: {
        title: 'Integraties.',
        text: 'Koppel jouw favoriete POS-systeem of externe tools.',
        button: '',
        img_alt: '',
      },
      card_3: {
        title: 'Beheer meerdere locaties.',
        text: 'Beheer eenvoudig meerdere locaties, indien van toepassing op jouw onderneming.',
        button: '',
        img_alt: '',
      },
      card_4: {
        title: 'Volg jouw betalingen.',
        text: 'Of verwerk terugbetalingen. Het gemiddelde terugbetalingspercentage bedraagt echter slechts 0,2%.',
        button: '',
        img_alt: '',
      },
      card_5: {
        title: 'Rapportages & Analyses.',
        text: 'Analyseer je online prestaties met basis- en geavanceerde rapportage opties.',
        button: '',
        img_alt: '',
      },
    },
  },
  testimonial: {
    text: '"De Manager wordt telkens vernieuwd, leuk om de ontwikkelingen te zien en mee te maken "',
    cta: 'Lees volledig verhaal',
    name: 'Istanbul Grillroom',
    job_title: 'Grillroom',
  },
  faq: {
    title_pt1: 'Alles over de',
    title_pt2: 'Bistroo Manager',
    items: [
      { q: 'Wat is de Bistroo Manager-app?', a: 'De Bistroo Manager is de centrale beheertool voor jouw online restaurant. Hiermee pas je het menu aan, beheer je bestellingen, stel je bezorggebieden in, bekijk je rapportages en houd je alles bij, vanaf elk apparaat.' },
      { q: 'Op welke apparaten werkt de Manager-app?', a: 'De Manager-app werkt op smartphone, tablet en desktop via de browser. Je hebt overal toegang zolang je een internetverbinding hebt, handig ook als je niet in de zaak bent.' },
      { q: 'Hoe pas ik mijn menu aan via de Manager?', a: 'Ga naar het menu-onderdeel in de Manager, selecteer een product of categorie en pas prijs, omschrijving, foto of beschikbaarheid aan. De wijziging is direct live op je webshop, kiosk en QR-shop.' },
      { q: 'Kan ik meerdere locaties beheren via één account?', a: 'Ja. Via de Manager beheer je meerdere vestigingen vanuit één dashboard. Per locatie stel je aparte menu\'s, openingstijden en bezorggebieden in.' },
      { q: 'Hoe stel ik bezorggebieden en -kosten in?', a: 'Teken je bezorggebieden nauwkeurig in op Google Maps in de Manager. Per zone stel je bezorgkosten, minimumorderbedragen en beschikbaarheid in. Aanpassingen zijn direct actief.' },
      { q: 'Hoe bekijk ik mijn omzetrapportages?', a: 'In de Manager vind je onder Rapportages een overzicht van omzet per dag, week of maand. Je ziet je bestverkochte producten, gemiddelde orderwaarden en trends die je helpen slimmere beslissingen te nemen.' },
      { q: 'Kan ik openingstijden aanpassen in realtime?', a: 'Ja. Sluit je shop met één klik voor een onverwachte dag vrij, pas tijdelijk je piektijden aan of zet extra tijdslots open op drukke dagen. Alles direct, zonder tussenkomst van Bistroo.' },
      { q: 'Hoe verwerk ik terugbetalingen via de Manager?', a: 'Ga naar de betreffende bestelling in het bestellingenoverzicht en kies voor Terugbetaling. Het bedrag wordt direct teruggestort op de betaalrekening van de klant. Het gemiddelde terugbetalingspercentage bij Bistroo-klanten ligt op slechts 0,2%.' },
      { q: 'Zijn er pushmeldingen voor nieuwe bestellingen?', a: 'Ja. De Manager-app stuurt direct een pushmelding bij elke nieuwe bestelling. Zo mis je nooit een order, ook niet als je even niet achter het scherm zit.' },
      { q: 'Wat zijn de kosten van de Bistroo Manager?', a: 'De Manager-app is inbegrepen bij elk Bistroo-pakket, ook het gratis pakket. Je hebt altijd volledige controle over je restaurant zonder extra kosten.' },
    ],
  },
}
